import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useDeviceDetect } from 'hooks';
import languages from 'config/languages';
import { WorldIcon } from 'components/elements/Icons';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function LanguageSelector({ classes, size }) {
  const styles = useStyles();
  const fieldClasses = cn(styles.langSelector, classes);
  const { isDesktop } = useDeviceDetect();
  const { i18n } = useTranslation();
  const { t } = useTranslation('labels');
  const { t: lang } = useTranslation('languages');

  return (
    <TextField
      className={fieldClasses}
      select
      label={t('language')}
      value={i18n.language}
      onChange={(event) => i18n.changeLanguage(event.target.value)}
      variant="outlined"
      size={size}
      SelectProps={{ MenuProps: { disableScrollLock: true } }}
      data-testid="language-selector"
      inputProps={{ id: 'languageSelectInput' }}
    >
      {languages.map((lng) => (
        <MenuItem key={lng.key} value={lng.key}>
          {lng.key === i18n.language && <WorldIcon className={styles.worldIcon} />}
          {isDesktop ? lang(lng.key) : lng.key.toUpperCase()}
        </MenuItem>
      ))}
    </TextField>
  );
}

LanguageSelector.propTypes = {
  classes: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
};

LanguageSelector.defaultProps = {
  classes: '',
  size: 'small',
};

export default LanguageSelector;
